export enum CommunicationMethodTypeCode {
  IP_PROTOCOL = "IP_PROTOCOL",
  SERIAL_CONNECTION = "SERIAL_CONNECTION",
  LON_CONNECTION = "LON_CONNECTION"
}

export const PROTOCOL_FORM_PARAMS = {
  communicationMethodTypeCode: "communicationMethodTypeCode",
  communication: "showAddress",
  ipAddress: "ipAddress",
  port: "port",
  address: "address",
  baudRate: "baudRate",
  forecourtEventClientIp: "forecourtEventClientIp",
  forecourtEventClientPort: "forecourtEventClientPort",
  deviceId: "deviceId",
  localNodeAddress: "localNodeAddress",
  recipientAddressTable: "recipientAddressTable",
  logicalDeviceId: "logicalDeviceId",
  subnet: "subnet",
  node: "node",
  maxBlockLength: "maxBlockLength",
  heartBeatInterval: "heartBeatInterval",
  parity: "parity",
  dataBits: "dataBits",
  stopBits: "stopBits",
  handshake: "handshake",
  timeout: "timeout"
};

export enum Parity {
  NONE = "NONE",
  ODD = "ODD",
  EVEN = "EVEN",
  MARK = "MARK",
  SPACE = "SPACE"
}

export enum StopBits {
  ONE = "ONE",
  TWO = "TWO",
  ONE_POINT_FIVE = "ONE_POINT_FIVE"
}

export enum Handshake {
  NONE = "NONE",
  XON_XOFF = "XON_XOFF",
  REQUEST_TO_SEND = "REQUEST_TO_SEND"
}